<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{loggedUserDisplayName}}!</h2>
          <span>{{bannerSubTitle}}</span>
        </div>
      </div>

      <div class="dashboard-hero-card">
        <div class="dashboard-hero-card__main">
          <section class="dashboard-section dashboard-section--hero">
            <app-getting-started></app-getting-started>
          </section>

          <section class="dashboard-section dashboard-section--recommended">
            <div class="dashboard-section__header">
              <h2 class="dashboard-section__title">{{ recommendedBy }}</h2>
              <a
                routerLink="/participants/courses"
                class="submit-form-button dashboard-section__action"
                [ngClass]="participantClassByRole">
                {{ courseButtonName }}
              </a>
            </div>
            <app-course-listing></app-course-listing>
          </section>
        </div>

        <div class="dashboard-combined-card__divider dashboard-combined-card__divider--hero" aria-hidden="true"></div>

        <aside class="dashboard-hero-card__sidebar">
          <section class="sidebar-card sidebar-card--mood">
            <div class="sidebar-card__header">
              <h2 class="sidebar-card__title">
                {{ 'moodCheckinText' | translate: translation }}
                <app-information-popup
                  class="info-popup-title"
                  popupAlign="start"
                  [information]="checkin_information">
                </app-information-popup>
              </h2>
            </div>
            <app-mood-checkin></app-mood-checkin>
          </section>

          <section class="sidebar-card sidebar-card--plans">
            <a
              routerLink="/participants/plans/add-plan"
              class="submit-form-button sidebar-card__primary-action"
              [ngClass]="participantClassByRole">
              {{ 'createPlan' | translate: translation }}
            </a>

            <div class="sidebar-card__header sidebar-card__header--plans">
              <h2 class="sidebar-card__title">{{ 'planningReminderText' | translate: translation }}</h2>
              <app-information-popup
                class="info-popup-inline"
                popupAlign="end"
                [information]="plan_information">
              </app-information-popup>
            </div>

            <app-plans-reminders></app-plans-reminders>
          </section>
        </aside>
      </div>

      <div class="clear"></div>
      <div class="mb-30"></div>
    </div>
  </div>

</div>
<div class="participant-dashboard-need-help" (click)="openNeedHelpModal()">
  <img src="assets/needhelp.svg" width="25" height="25">
  {{'needHelp'|translate:translation}}
</div>

<app-footer [bbapp]="true"></app-footer>
